// extracted by mini-css-extract-plugin
export default {"image":"RestaurantImage_image__7pz2h"};